import {readClaimTypes} from './get-claim-types';
import {readClaims} from './get-claim-results';

export const initializeComponent = (accounts, searchFilters) =>
    async (dispatch, getState) => {

        await readClaimTypes()(dispatch);
        const newFacets = getState().tcsm.addClaimsToAudit.facets;

        readClaims(accounts, newFacets, searchFilters)(dispatch);

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/init.js